import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import { MATERIAL_ITEMS_PATH } from "~produce/production/materialItems/helpers/materialContinuation";

const MATERIAL_ITEM_TARGET_KIND = "materialItem";

const MATERIAL_ITEMS_DOCK_PAGE_ID = "material-items";

const MATERIAL_ITEM_ROUTE_PATTERN = /^\/produce\/production\/material-items\/([^/?#]+)$/;

const matchMaterialItemReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = MATERIAL_ITEM_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: MATERIAL_ITEM_TARGET_KIND };
	} catch {
		return null;
	}
};

const materialItemReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${MATERIAL_ITEMS_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchMaterialItemReceiverRoute
};

const MATERIAL_ITEM_TARGET_KINDS = [MATERIAL_ITEM_TARGET_KIND];

const materialReceiverIdentity = {
	adapter: materialItemReceiverIdentityAdapter,
	MATERIAL_ITEM_TARGET_KIND,
	MATERIAL_ITEM_TARGET_KINDS,
	MATERIAL_ITEMS_DOCK_PAGE_ID,
	matchMaterialItemReceiverRoute
} as const;

export default materialReceiverIdentity;
